export default function (
  listData,
  firstBarKey = "ticket_count",
  secondBarYey = "total_ticket_value",
  minCol = 12
) {
  const toNumber = (value) => +parseFloat(value || 0).toFixed(2);
  const dataArray = listData || [];
  const labels = [];
  const datasets = [
    {
      label: "Ticket Count",
      fill: true,
      borderColor: "#00D0FF",
      backgroundColor: "#00D0FF",
      pointBorderColor: "#00D0FF",
      borderWidth: 3,
      barThickness: 20,
      yAxisID: "y",
      data: [],
    },
    {
      label: "Total Ticket Value",
      fill: true,
      borderColor: "#EA00FF",
      backgroundColor: "#EA00FF",
      pointBorderColor: "#EA00FF",
      borderWidth: 3,
      barThickness: 20,
      yAxisID: "y1",
      data: [],
    },
  ];
  if (dataArray && dataArray.length > 0) {
    dataArray.forEach((x) => {
      labels.push(`${x.year}`);
      datasets[0].data.push(toNumber(x[firstBarKey]));
    });
    dataArray.forEach((y) => {
      datasets[1].data.push(toNumber(y[secondBarYey]));
    });
  }
  return {
    labels,
    datasets,
  };
}
